export { default as IconPoll } from './IconPoll';
export { default as IconSurvey } from './IconSurvey';
export { default as IconTemplate } from './IconTemplate';
